module.exports = __webpack_public_path__ + "static/media/calendar-clock-inactive.1190579d.svg";